import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { PropTypesRepo } from '../functions/_propTypes';

import Icon from './Icon';

const RadioboxInput = styled.input`
  display: none;

  ~ div {
    svg:nth-child(1) {
      display: none;
    }
    svg:nth-child(2) {
      display: block;
    }
  }

  &:checked ~ div {
    svg:nth-child(1) {
      display: block;
    }
    svg:nth-child(2) {
      display: none;
    }
  }
`;

const Radiobox = ({ m, size, activeColor, inactiveColor, isLoading, value, selectedValue, checked, ...rest }) => (
  <>
    <RadioboxInput type="radio" {...rest} checked={value ? value === selectedValue : checked} />
    <div>
      <Icon m={m} name={isLoading ? 'Loading' : 'RBChecked'} color={activeColor} size={size} />
      <Icon m={m} name={isLoading ? 'Loading' : 'RBUnchecked'} color={inactiveColor} size={size} />
    </div>
  </>
);

/* eslint-disable react/forbid-prop-types */

Radiobox.propTypes = {
  m: PropTypesRepo.m,
  size: PropTypesRepo.d,
  activeColor: PropTypes.string,
  inactiveColor: PropTypes.string,
  isLoading: PropTypes.bool,
  value: PropTypes.any,
  selectedValue: PropTypes.any,
  checked: PropTypes.bool,
  cursor: PropTypesRepo.cursor,
  disabled: PropTypes.bool,
  name: PropTypes.string,
};

/* eslint-enable react/forbid-prop-types */

Radiobox.defaultProps = {
  cursor: 'pointer',
  m: { r: '8px' },
  size: '20px',
  inactiveColor: 'gray500',
  activeColor: 'info700',
  isLoading: false,
  value: undefined,
  selectedValue: undefined,
  checked: undefined,
  disabled: false,
  name: undefined,
};

export default Radiobox;
